import React from "react";

const How = ({ lieu_intervention, todelete = false, setHow, onRemoveOption, className = "",from }) => {
  const deleteLieu = (lieu) => {
    if (onRemoveOption) {
      onRemoveOption(lieu);
    }
    if (setHow) {
      const updatedLieuIntervention = lieu_intervention?.filter((item) => item !== lieu);
      setHow(updatedLieuIntervention);
    }
  };

  // Create a sorted copy of the array instead of sorting the original
  const sortedLieuIntervention = lieu_intervention 
    ? [...lieu_intervention].sort((a, b) => {
        const order = ["enligne", "onsite", "chezpro"];
        return order.indexOf(a) - order.indexOf(b);
      })
    : [];

  return (
    <div className={`service-badges ${from!=='type' ?'justify-content-end':''}`}>
      {sortedLieuIntervention.map((lieu, index) => {
        return (
          <React.Fragment key={index}>
            {lieu === "enligne" && (
              <div className={`${className} service-badge d-flex align-items-center`}>
                <img src="/images/enligne.svg" alt="En ligne" /> En ligne
                {todelete && (
                  <div className="link-blue" onClick={() => deleteLieu("enligne")}>
                    <img src="/images/x-03.svg" alt="x icon" />
                  </div>
                )}
              </div>
            )}
            {lieu === "onsite" && (
              <div className={`${className} service-badge d-flex align-items-center`}>
                <img src="/images/domicile.svg" alt="Domicile" /> À domicile
                {todelete && (
                  <div className="link-blue" onClick={() => deleteLieu("onsite")}>
                    <img src="/images/x-03.svg" alt="x icon" />
                  </div>
                )}
              </div>
            )}
            {lieu === "chezpro" && (
              <div className={`${className} service-badge d-flex align-items-center`}>
                <img src="/images/chezpro.svg" alt="Chez Pro" /> Chez le Professionnel
                {todelete && (
                  <div className="link-blue" onClick={() => deleteLieu("chezpro")}>
                    <img src="/images/x-03.svg" alt="x icon" />
                  </div>
                )}
              </div>
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default How;